import React from 'react';
import { MediaGallery } from '../media/MediaGallery';
import type { GalleryItem } from './announcementMedia';

export const AnnouncementGallery: React.FC<{
  onInsert: (element: GalleryItem) => void;
  onError: (message: string) => void;
}> = ({ onInsert, onError }) => (
  <MediaGallery mode="manage" onInsert={onInsert} onError={onError} />
);
